export { default } from './mergeClasses';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/mergeClasses/index.js
// module id = 615
// module chunks = 121